import Box from '@zenbusiness/zui/Box';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Text from '@zenbusiness/zui/Text';

import { NoTransactionWrapper } from '../styles';

export default function NoTransaction() {
  return (
    <NoTransactionWrapper
      alignItems="center"
      gap="9px"
      marginBottom={{ xs: '8px', md: '12px' }}
      marginTop={{ xs: '16px', md: '32px' }}
    >
      <Box pt={{ xs: '16px', md: '40px' }}>
        <SharedAsset
          alt=""
          height={80}
          src="/s2/vector/transactions-inactive.svg"
          width={80}
        />
      </Box>
      <Text
        align="center"
        size="md"
      >
        You don&apos;t have any transactions yet
      </Text>
    </NoTransactionWrapper>
  );
}
